<script>
  import Navigate from "../Classes/Navigate";
  import Menu from "./Menu.svelte";
  import { Burger } from "@svelteuidev/core";
  import { DadosPaginaAnterior, versaoTeste } from "../Classes/Stores";
  import Constantes from "../Classes/Constantes";
  let navi = new Navigate();
  export let pagAnterior = "";

  let opened = false;
  let menuOpen = false;

  function acaoBotao() {
    menuOpen = !menuOpen;
    opened = !opened;
  }

  function Retornar() {
    if (
      window.location.pathname + window.location.search ==
      Constantes.tela_menu
    ) {
      navi.goTo($DadosPaginaAnterior.pagina);
    } else {
      navi.goTo(Constantes.tela_menu);
    }
  }
</script>

<nav class="navbar navbar-expand-lg navbar-orange fixed-top">
  <div class="container">
    <div class="d-flex align-items-center">
      {#if $DadosPaginaAnterior.pagina && $DadosPaginaAnterior.pagina != "/"}
        <span on:click={Retornar} class="navbar-brand branca me-3">
          <i class="fas fa-arrow-left"></i>
        </span>
      {/if}
      <a class="navbar-brand" href="/">
        <img src="img/fitpace_logo.png" alt="Logo" height="50" />
      </a>
    </div>
    {#if $versaoTeste == 1}
      <h6>V. TESTE</h6>
    {/if}
     <Menu {menuOpen} />
  </div>
 
</nav>




<style>
  .navbar-orange {
    background-color: #eb4f12; /* Cor laranja */
    border-bottom: 2px solid #3f3f3f; /* Borda inferior */
    padding: 0.2rem; /* Reduzir espaçamento superior */
   
  }

  .navbar-brand img {
    height: 25px; /* Reduz o tamanho do logotipo */
  }

  .navbar-brand.branca {
    font-size: 0.8rem; /* Ajusta o tamanho do texto da navbar */
  }

  .navbar h6 {
    font-size: 0.8rem; /* Reduz o tamanho do texto da versão teste */
    margin: 0;
  }

  .fixed-top {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 990; /* Z-index maior que o conteúdo */
  }

  .navbar-brand.me-3 {
    margin-right: 0.5rem; /* Ajusta o espaço entre os elementos */
  }

  .content-below-nav {
    margin-top: 4em; /* Ajusta para compensar o novo tamanho da navbar */
  }

  .branca {
    color: white;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Adicionando animação ao ícone */
  .rotate-effect {
    animation: rotate 0.3s linear;
  }
</style>
